import { CURRENCIES, type CurrencyCode } from '../config/currency';

/**
 * Arrondit un montant monétaire à 2 décimales (par défaut).
 * Utilise la méthode Math.round(x * 10^n) / 10^n pour éviter
 * les erreurs d'arrondi IEEE 754.
 */
export function roundMoney(value: number, decimals: number = 2): number {
  const factor = Math.pow(10, decimals);
  return Math.round(value * factor) / factor;
}

/**
 * Additionne un tableau de nombres avec arrondi final.
 * Remplace le pattern `.reduce((sum, x) => sum + x, 0)` qui accumule des erreurs float.
 */
export function sumMoney(values: number[]): number {
  return roundMoney(values.reduce((sum, v) => sum + (v || 0), 0));
}

/**
 * Comparaison de deux montants avec tolérance (0.01 par défaut).
 * Remplace les `===` sur des floats.
 */
export function moneyEqual(a: number, b: number, tolerance: number = 0.005): boolean {
  return Math.abs(a - b) < tolerance;
}

export function formatCurrency(amount: number, currency: CurrencyCode = 'CDF'): string {
  return new Intl.NumberFormat('fr-CD', {
    style: 'currency',
    currency,
    maximumFractionDigits: 0
  }).format(amount);
}

export function formatCompactCurrency(amount: number, currency: CurrencyCode = 'CDF'): string {
  const millions = amount / 1000000;
  return `${millions.toFixed(1)}M ${CURRENCIES[currency].symbol}`;
}

export function calculateVariation(current: number, previous: number): number {
  if (!previous) return 0;
  return roundMoney(((current - previous) / previous) * 100);
}